
























import TheAboutList from "@/layouts/navigation/TheAboutList.vue";
import TheAdminList from "@/layouts/navigation/TheAdminList.vue";
import TheNavigationDrawerHeader from "@/layouts/navigation/TheNavigationDrawerHeader.vue";
import ThePartnerList from "@/layouts/navigation/ThePartnerList.vue";
import ThePartnerSelectorList from "@/layouts/navigation/ThePartnerSelectorList.vue";
import TheSettingsList from "@/layouts/navigation/TheSettingsList.vue";
import TheThgAdminList from "@/layouts/navigation/TheThgAdminList.vue";
import TheThgAnalyticsList from "@/layouts/navigation/TheThgAnalyticsList.vue";
import TheThgList from "@/layouts/navigation/TheThgList.vue";
import TheThgPartnerList from "@/layouts/navigation/TheThgPartnerList.vue";
import TheThgProcessingList from "@/layouts/navigation/TheThgProcessingList.vue";
import TheUserList from "@/layouts/navigation/TheUserList.vue";
import ThgAboutList from "@/layouts/navigation/ThgAboutList.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { UiModule } from "@/store/modules/ui.store";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    TheNavigationDrawerHeader,
    TheAboutList,
    ThePartnerList,
    TheUserList,
    TheAdminList,
    TheSettingsList,
    ThePartnerSelectorList,
    TheThgList,
    ThgAboutList,
    TheThgAdminList,
    TheThgProcessingList,
    TheThgPartnerList,
    TheThgAnalyticsList
  }
})
export default class TheNavigationBase extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;
  selectedItem = 1;

  get navigationSettings() {
    return ConfigModule.navigationSettigns;
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get drawer() {
    return UiModule.drawer;
  }

  set drawer(val: boolean) {
    UiModule.setDrawer(val);
  }

  login() {
    this.$router.push({ name: "Login" });
  }
}
